import { Button, Checkbox, Form, Modal } from "antd";
import React, { Fragment, useState } from "react";
import ChildPriPol from "../../../components/childPriPol/childPriPol";

export default function SignupModal({
  isPolicyModal,
  setIsPolicyModal,
  handleSignupApi,
}) {
  const [isDisagreeModal, setIsDisagreeModal] = useState(false);

  const policyFooter = (
    <Form
      onFinish={() => {
        setIsPolicyModal(false);
        handleSignupApi();
      }}
      className="policy-footer"
    >
      <Form.Item
        name="agreement"
        valuePropName="checked"
        className="signup-checkbox"
        rules={[
          {
            validator: (_, value) => {
              console.log(value);
              return value
                ? Promise.resolve()
                : Promise.reject(
                    "Please accept the term of usage before moving ahead"
                  );
            },
          },
        ]}
      >
        <Checkbox>
          I have read and understood the above and give my consent to collect
          data.
        </Checkbox>
      </Form.Item>

      <button
        className="custom-btn one"
        onClick={() => {
          setIsPolicyModal(false);
          setIsDisagreeModal(true);
        }}
      >
        DISAGREE
      </button>

      <Form.Item className="agree-btn">
        <Button htmlType="submit" className="custom-btn two">
          AGREE
        </Button>
      </Form.Item>
    </Form>
  );
  const disagreeFooter = (
    <div className="disagree-footer">
      <button
        className="custom-btn"
        onClick={() => {
          setIsDisagreeModal(false);
        }}
      >
        Cancel Registration
      </button>
      <button
        className="custom-btn"
        onClick={() => {
          setIsDisagreeModal(false);
          setIsPolicyModal(true);
        }}
      >
        Go Back
      </button>
    </div>
  );
  return (
    <Fragment>
      <Modal
        style={{
          top: 40,
        }}
        width={720}
        className="policy-modal"
        visible={isPolicyModal}
        footer={policyFooter}
        closeIcon={false}
      >
        <div className="child-policy-modal">
          <ChildPriPol />
        </div>
      </Modal>
      <Modal
        className="policy-modal"
        visible={isDisagreeModal}
        footer={disagreeFooter}
      >
        <div className="">
          <h1>Children’s Privacy Policy</h1>
          <p>
            If you disagree we will not be able to register you or your child on
            the Amaze app
            <br />
            Would you like to cancel registration or review the policy
          </p>
        </div>
      </Modal>
    </Fragment>
  );
}
